import { render, staticRenderFns } from "./PaapViewer.vue?vue&type=template&id=2362d712"
import script from "./PaapViewer.vue?vue&type=script&lang=js"
export * from "./PaapViewer.vue?vue&type=script&lang=js"
import style0 from "@/assets/LAcordion.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/PaapViewer.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports